import React from 'react';
import { SearchSelect } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/components/SearchSelect';
import { useAppSelector } from 'src/utils/Hooks';
import { usePresentationFormContext } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationFormContext';
import { FormValue } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/types';

interface CategorySelectProps {
  selectionOrder: 'category' | 'subcategory' | null;
  onSelectionChange: (newValue: FormValue[]) => void;
  selectedSubcategoryIds: FormValue[];
}

export const CategorySelect = ({ selectionOrder, onSelectionChange, selectedSubcategoryIds }: CategorySelectProps) => {
  const {
    selections: { control }
  } = usePresentationFormContext();
  const categories = useAppSelector((state) => state.categories);
  const subCategories = useAppSelector((state) => state.subCategories);

  const selectOptions = React.useMemo(() => {
    let filteredCategories = categories.filter(category => category.id !== 0);

    if (selectionOrder === 'subcategory' && selectedSubcategoryIds.length > 0) {
      const selectedSubcats = subCategories.filter(subcat =>
        selectedSubcategoryIds.some(selected => selected.id === subcat.id.toString())
      );

      const parentCategoryIds = new Set(
        selectedSubcats.map(subcat => subcat.parentCategoryId)
      );

      filteredCategories = filteredCategories.filter(category =>
        parentCategoryIds.has(category.id)
      );
    }

    return filteredCategories.map((category) => ({
      id: category.id,
      value: category.id.toString(),
      displayName: category.categoryName
    }));
  }, [categories, subCategories, selectionOrder, selectedSubcategoryIds]);

  return (
    <SearchSelect
      name="categoryIds"
      title="Category Inclusions"
      placeholder="Search or select categories you would like to add to your presentation"
      selectOptions={selectOptions}
      isMulti={true}
      control={control}
      onSelectionChange={onSelectionChange}
    />
  );
};
